/**
 * Variation id the user is bucketed to, from `document.body`’s `data-gb-variation`.
 * Example: `data-gb-variation="HSMERCH-5604-1"` with feature key `HSMERCH-5604` → `'1'`.
 *
 * @param {String} featureKey - Feature id prefix in the attribute (e.g. `'HSMERCH-5604'`).
 * @returns {String} - Digits after `{featureKey}-`, or `''` if missing / no match.
 */
export default function activeVariationByExp(featureKey) {
	if (!featureKey || typeof document === 'undefined' || !document.body) {
		return '';
	}

	const variationDataAttr = document.body.getAttribute('data-gb-variation');
	if (!variationDataAttr) {
		return '';
	}

	const cleanedFeatureKey = featureKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	const match = variationDataAttr.match(new RegExp(cleanedFeatureKey + '-(\\d+)'));
	return match ? match[1] : '';
}
